import { useEffect } from "react";
import { bool, func, number, shape, string } from "prop-types";
import { connect } from "react-redux";
import { replace } from "react-router-redux";

import { actions as communicationActions } from "reducers/communication";
import { actions as echeqMassManagementActions } from "reducers/echeqMassManagement";

import { ECHEQS_MASS_MANAGEMENT_LIST_PATH } from "./echeqMassManageConstants";
import {
    buildListFiltersFromNotificationQuery,
    MASS_ECHEQ_MANAGE_NOTIFICATION_WARNING_KEY,
} from "./echeqMassManageNotificationLinkUtils";

function EcheqsMassManageNotificationEntry({ dispatch, match, location, activeEnvironment, isDesktop }) {
    useEffect(() => {
        const envId = match?.params?.envId;
        const envName = decodeURIComponent(match?.params?.envName || "");

        if (envId && String(activeEnvironment?.id) !== String(envId)) {
            dispatch(
                communicationActions.showWrongEnvironmentModal(envName, MASS_ECHEQ_MANAGE_NOTIFICATION_WARNING_KEY),
            );
        } else {
            const filters = buildListFiltersFromNotificationQuery(location?.search || "");
            dispatch(echeqMassManagementActions.listRequest(filters, isDesktop, true));
        }

        dispatch(replace(ECHEQS_MASS_MANAGEMENT_LIST_PATH));
    }, []);

    return null;
}

EcheqsMassManageNotificationEntry.propTypes = {
    dispatch: func.isRequired,
    isDesktop: bool.isRequired,
    activeEnvironment: shape({
        id: number,
    }).isRequired,
    match: shape({
        params: shape({
            envId: string,
            envName: string,
        }),
    }),
    location: shape({
        search: string,
    }),
};

EcheqsMassManageNotificationEntry.defaultProps = {
    match: null,
    location: null,
};

const mapStateToProps = (state) => ({
    activeEnvironment: state.session.activeEnvironment,
    isDesktop: state.settings?.isDesktop ?? true,
});

export default connect(mapStateToProps)(EcheqsMassManageNotificationEntry);
